/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { is } from 'bpmn-js/lib/util/ModelUtil';

import { findExtensionElement } from 'utils/web-modeler-diagram-parser/extension-elements-util';

export function getBusinessRuleTasksWithLinkedDecision(modeler) {
  const elementRegistry = modeler.get('elementRegistry');

  const businessRuleTasks = elementRegistry.filter((element) => is(element, 'bpmn:BusinessRuleTask'));

  return businessRuleTasks.filter((element) => {
    const calledDecision = findExtensionElement(element, 'zeebe:CalledDecision');

    if (!calledDecision) {
      return false;
    }

    const decisionId = calledDecision.get('decisionId');

    return typeof decisionId === 'string' && decisionId.trim().length > 0;
  });
}
